import { ValidateNested } from "class-validator";
import { Length } from "./Length";
import { LengthType } from "./LengthType";
import LengthValue from "./LengthValue";
import { LengthValueMillimeter } from "./LengthValueMillimeter";
import { Expose, Transform, Type } from "class-transformer";

export class RangeLength extends Length {
    
    get value(): number {
        return this.default.millimeter;
    };
    
    lengthType: LengthType = LengthType.Range;

    lengthValue?: LengthValue | undefined;

    @Expose()
    @ValidateNested()
    @Type(() => LengthValue)
    default: LengthValue;

    @Expose()
    @ValidateNested()
    @Type(() => LengthValue)
    start: LengthValue;

    @Expose()
    @ValidateNested()
    @Type(() => LengthValue)
    stop: LengthValue;

    @Expose()
    @ValidateNested()
    @Type(() => LengthValue)
    step: LengthValue;

    constructor(start?: LengthValue, stop?: LengthValue, step?: LengthValue, defaultValue?: LengthValue);
    constructor(start?: number, stop?: number, step?: number, defaultValue?: number);
    constructor(start?: any, stop?: any, step?: any, defaultValue?: any) {
        super();
        if (typeof start === 'number' && typeof stop === 'number' && (typeof step === 'number' || step === undefined) && typeof defaultValue === 'number') {
            this.start = new LengthValueMillimeter(start);
            this.stop = new LengthValueMillimeter(stop);
            this.step = new LengthValueMillimeter(step ?? 1);
            this.default = new LengthValueMillimeter(defaultValue);
        } else if (start instanceof LengthValue && stop instanceof LengthValue && (step instanceof LengthValue || step === undefined) && defaultValue instanceof LengthValue) {
            this.start = start;
            this.stop = stop;
            this.step = step ?? new LengthValueMillimeter(1);
            this.default = defaultValue;
        } else {
            throw new Error('Invalid constructor arguments');
        }
    }

    toString(): string {
        return `${this.start.millimeter}-${this.stop.millimeter}:${this.default.millimeter}/${this.step.millimeter}`;
    }
}

export default RangeLength;
